(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bjc-curated-grid"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){
  const opener=event.target.closest('[data-bjc-open]');
  if(opener){const dialog=document.getElementById(opener.dataset.bjcOpen);if(dialog){dialog.showModal();dialog.querySelector('[data-bjc-close]').focus();}return;}
  const closer=event.target.closest('[data-bjc-close]');if(closer){closer.closest('dialog').close();return;}
  if(event.target.matches('.bjc-preview-dialog')){const box=event.target.getBoundingClientRect();if(event.clientX<box.left||event.clientX>box.right||event.clientY<box.top||event.clientY>box.bottom)event.target.close();}
});

  } catch(e) { console.error(e); }
})();
})();
